import { forwardRef, useImperativeHandle, useState } from "react"

import BlurWrapper from "@fuse/sharedComponents/blurWrapper"

import { DeviceTypes, DownloadLinkMap } from "@fuse/utils/DeviceDection"

import appStore from "@fuse/assets/images/img-app-store.svg"
import playStore from "@fuse/assets/images/img-play-store.svg"

export interface AdminDownloadAppModalHandle {
  openModal: () => void
  closeModal: () => void
}

const AdminDownloadAppModal = forwardRef<AdminDownloadAppModalHandle>(
  (_, ref) => {
    // Expose methods to parent via ref for compatibility
    useImperativeHandle(ref, () => ({
      openModal: () => {
        // No-op: removed download modal functionality
      },
      closeModal: () => {
        // No-op: removed download modal functionality
      },
    }))

    // Removed download app modal - no longer encouraging app downloads
    return null
  },
)

export default AdminDownloadAppModal
